import { render } from "./HlsPlayer.vue?vue&type=template&id=50573151"
import script from "./HlsPlayer.vue?vue&type=script&lang=js"
export * from "./HlsPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/edu.intelschool.com.ua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__